export default __webpack_public_path__ + "static/media/storesampler2.6cd05f1d.png";